import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {interval, Observable, Subscription} from 'rxjs';
import {AuthorizationService} from '../../../../services/authorization.service';
import {BreadcrumbModel} from '../../../shared/models/Breadcrumb.class';
// import {NotificationService} from '../../../messagingcenter/services/notification.service';
import {MatDialog} from '@angular/material/dialog';
import {NotificationMessage} from './models/notification-message';


@Component({
    selector: 'app-agent-notification',
    templateUrl: './user-notification.component.html',
    styleUrls: ['./user-notification.component.css']
})
export class UserNotificationComponent implements OnInit, OnDestroy {

    @ViewChild('customNotification', {static: true}) customNotificationTmpl;



    private globalNotifObserver;

    constructor(
                private authorization: AuthorizationService,

                private dialog: MatDialog,
                private auth: AuthorizationService) {
        this.auth.requierPermission('view_notifications');


    }

    notifications: NotificationMessage[] = [];
    count_unread = 0;
    crumbs: BreadcrumbModel[];
    source = interval(120000);
    subscription: Subscription;

    ngOnInit() {

        this.loadNotifications();

        // this.globalNotifObserver = this.globalNotificationService.globalNotificationGeneratedEvent.subscribe(notif => {
        //     //console.log(notif.title);
        //     var message = new NotificationMessage();
        //     message.subject = notif.title;
        //     message.text = notif.text;
        //
        // });


        // this.subscription = this.source.subscribe(val => {
        //     this.loadNotifications();
        // });


    }


    loadNotifications() {

        var current_user = this.authorization.getCurrentlyLoggedUser();
        if (!current_user) {
            return;
        }
        // this.notService.getRecentNotifications(current_user.id).subscribe(response => {
        //
        //     // if (this.notifications.length > 4) {
        //     //     for (let i = 0; i < 4; i++) {
        //     //         this.notifications.push(response[i]);
        //     //     }
        //     // } else {
        //     this.count_unread = response.count_unread;
        //     this.notifications = response.notifications;
        //
        //     let i = 0;
        //     for (i = 0; i < this.notifications.length; i++) {
        //         if (this.notifications[i].notification.sysevent_id === 15 &&
        //             this.notifications[i].seen === 0
        //         ) {
        //
        //             //   this.openDialog(this.notifications[i]);
        //             //   this.notService.notificationSeen(this.notifications[i].id).subscribe(response => {
        //
        //             //   });
        //
        //         }
        //     }
        //
        //
        // });

    }




    setSeen() {

        this.count_unread = 0;
        // this.notService.notificationAllSeen().subscribe(response => {
        //
        // });

    }

    ngOnDestroy(): void {

        if (this.subscription) {
            this.subscription.unsubscribe();
        }

        if (this.globalNotifObserver) {
            this.globalNotifObserver.unsubscribe();
        }
    }

}
